
export interface languageObject {
    German: string[],
    English: string[]
}

export const placeholder: languageObject = {
    German: ["tt.mm.jjjj"],
    English: ["dd.mm.yyyy"]
};

export const weekday: languageObject = {
    German: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"],
    English: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"]
};

export const month: languageObject = {
    German: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    English:["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}

export const datepickerNavigation =  {
    previous: {
        German: ["Vorheriges"],
        English:["Previous"]
    },
    next: {
        German: ["Nächstes"],
        English:["Next"]
    }
}

export const date = {
    day: {
        German: ["Tag"],
        English: ["Day"]
    },
   month: {
        German: ["Monat"],
        English: ["Month"]
   },
   year: {
        German: ["Jahr"],
        English: ["Year"]
   }
}
